import {toArray, flatten} from "lodash";

export function formatterErrorsLaravel(error, messageDefault = 'Não foi possível atender o pedido') {
    let formatted;

    if (error?.response && Object.prototype.hasOwnProperty.call(error.response, 'data')) {
        if (typeof error.response.data?.errors === 'object') {
            formatted = flatten(toArray(error.response.data.errors));
        } else if (typeof error.response.data === 'object') {
            formatted = flatten(toArray(error.response.data));
        } else if (error.response.data && Object.prototype.hasOwnProperty.call(error.response.data, 'message')) {
            formatted = [error.response.data.message];
        } else {
            formatted = [error.response.data];
        }
    } else if (error && Object.prototype.hasOwnProperty.call(error, 'message')) {
        formatted = [error.message];
    } else {
        formatted = [messageDefault];
    }

    return formatted;
}

export const store = (url = null, name = null, title = "Pesquisa guardada com sucesso!") => {
    // Primeiro obter o CSRF cookie para autenticação Sanctum
    return axios.get('/sanctum/csrf-cookie').then(() => {
        return axios.post(route('api.savedSearch.store'), {
            url: url ? url : window.location.href,
            name: name ? name : document.querySelector('#name-search').value
        })
    }).then(() => {
        try {
            const modalSaveSearch = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-save-search'))
            modalSaveSearch.hide();
        } catch (e) {}
        // Swal.fire({
        //     position: 'top-end',
        //     toast: true,
        //     title,
        //     timer: 5000,
        //     timerProgressBar: true,
        //     icon: 'success',
        //     showConfirmButton: false,
        // })
        setTimeout(function () {
            $('#modal-save-search').modal('hide');
            $('#successSaveSearchModal').modal('show');
        }, 200);
        setTimeout(function () {
            $('#successSaveSearchModal').modal('hide')
        }, 3000);
        return Promise.resolve()
    }).catch((e) => {
        const errors = formatterErrorsLaravel(e)
        // Swal.fire({
        //     position: 'top-end',
        //     toast: true,
        //     title: errors.join('<br/>'),
        //     timer: 8000,
        //     timerProgressBar: true,
        //     icon: 'error',
        //     showConfirmButton: false,
        // })
        return Promise.reject()
    })
}

// Função para anexar o event listener
function attachSaveSearchListener() {
    const el = document.querySelector('#btn-store-search')
    if (el && ! el.getAttribute('data-observable')) {
        el.setAttribute('data-observable', '1')
        el.addEventListener('click', (e) => {
            e.preventDefault();
            store()
        })
    }
}

// Fix aria-hidden accessibility issue
function setupModalAccessibility() {
    const modalEl = document.getElementById('modal-save-search')
    if (modalEl) {
        // Quando o modal é mostrado, remover aria-hidden
        modalEl.addEventListener('shown.bs.modal', function () {
            this.removeAttribute('aria-hidden')
            this.setAttribute('aria-modal', 'true')
        })

        // Quando o modal é escondido, adicionar aria-hidden
        modalEl.addEventListener('hidden.bs.modal', function () {
            this.setAttribute('aria-hidden', 'true')
            this.removeAttribute('aria-modal')
        })
    }
}

// Executar quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        attachSaveSearchListener()
        setupModalAccessibility()
    })
} else {
    // DOM já está pronto, executar imediatamente
    attachSaveSearchListener()
    setupModalAccessibility()
}
